const landing_page = {
  aboutUs: "हमारे बारे में", // translated 
  topPackages: "शीर्ष पैकेज", // translated 
  featuredHotels: "विशेष होटल", // translated 
  topTours: "शीर्ष पर्यटन", // translated 
  whatOurMembersSay: "हमारे सदस्यों का क्या कहना है...", // translated 
  followUsOnInstagram: "हमें इंस्टाग्राम पर फॉलो करें", // translated 
  pleaseWait: "कृपया प्रतीक्षा करें...", // translated 
  packages: "संकुल", // translated 
  ourPartners: "हमारे सहयोगियों", // translated 
  trustedCarHirePartners: "विश्वसनीय कार किराए पर देने वाले भागीदार", // translated 
  learnMore: "और अधिक जानें", // translated 
};


export default landing_page;
